import { css } from 'styled-components'

export const smallLabel = css`
    font-size: 12px;
    bottom: 5px;
`
